import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 公司组织结构节点
 */
const orgStructNode = {

  /**
   * 创建
   */
  addORGStructNode (name, orderNum, parentId, loginPassword) {
    return axios.post(base.orgStructNode.addORGStructNode, utils.postParamsArrayToJsonString({ name, orderNum, parentId, loginPassword }))
  },
  /**
   * 修改
   */
  modifyORGStructNode (nodeId, name, orderNum, parentId, loginPassword) {
    return axios.post(base.orgStructNode.modifyORGStructNode, utils.postParamsArrayToJsonString({ nodeId, name, orderNum, parentId, loginPassword }))
  },
  /**
   * 删除
   */
  deleteORGStructNode (nodeId, loginPassword) {
    return axios.post(base.orgStructNode.deleteORGStructNode, utils.postParamsArrayToJsonString({ nodeId, loginPassword }))
  },
  /**
   * 查询
   */
  getORGStructNodes (companyId) {
    return axios.post(base.orgStructNode.getORGStructNodes, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 查询挂接测量点
   */
  getMountedMeasures (nodeId) {
    return axios.post(base.orgStructNode.getMountedMeasures, utils.postParamsArrayToJsonString({ nodeId }))
  },
  /**
   * 查询挂接角色
   */
  getMountedRoles (nodeId) {
    return axios.post(base.orgStructNode.getMountedRoles, utils.postParamsArrayToJsonString({ nodeId }))
  },
}

export default orgStructNode